module.exports = __webpack_public_path__ + "img/music-ai.5343f5cc.png";